/**
 * CTR Combo FAQs — accordion
 * Desktop/mobile Figma: 2750:2704 / 2763:3301
 */
(function () {
  'use strict';

  const SELECTOR = '.ctr-combo-faqs';

  function initSection(section) {
    if (!section || section.dataset.cfqBound === 'true') return;
    section.dataset.cfqBound = 'true';

    const list = section.querySelector('[data-cfq-list]');
    if (!list) return;

    const allowMultiple = list.dataset.allowMultiple === 'true';
    const items = Array.from(list.querySelectorAll('[data-cfq-item]'));

    items.forEach((item) => {
      const trigger = item.querySelector('[data-cfq-trigger]');
      const panel = item.querySelector('[data-cfq-panel]');
      if (!trigger || !panel) return;

      if (item.dataset.openDefault === 'true') {
        openItem(item, panel, false);
      } else {
        closeItem(item, panel, false);
      }

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (!allowMultiple && !isOpen) {
          items.forEach((other) => {
            if (other === item || !other.classList.contains('is-open')) return;
            const otherPanel = other.querySelector('[data-cfq-panel]');
            if (otherPanel) closeItem(other, otherPanel, true);
          });
        }

        if (isOpen) {
          closeItem(item, panel, true);
        } else {
          openItem(item, panel, true);
        }
      });
    });
  }

  function openItem(item, panel, animate) {
    item.classList.add('is-open');
    const trigger = item.querySelector('[data-cfq-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    panel.hidden = false;

    if (!animate) {
      panel.style.height = 'auto';
      return;
    }

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      panel.style.height = 'auto';
      return;
    }

    const inner = panel.querySelector('.ctr-combo-faqs__panel-inner');
    const target = inner ? inner.scrollHeight : panel.scrollHeight;
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.transition = 'height 0.28s ease';
    panel.style.height = target + 'px';

    const onEnd = () => {
      panel.style.height = 'auto';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function closeItem(item, panel, animate) {
    const trigger = item.querySelector('[data-cfq-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (!animate) {
      panel.style.height = '0px';
      panel.hidden = true;
      item.classList.remove('is-open');
      return;
    }

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      panel.style.height = '0px';
      panel.hidden = true;
      item.classList.remove('is-open');
      return;
    }

    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.transition = 'height 0.28s ease';
    panel.style.height = '0px';

    const onEnd = () => {
      panel.hidden = true;
      panel.style.transition = '';
      item.classList.remove('is-open');
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
    if (section) {
      section.dataset.cfqBound = '';
      initSection(section);
    }
  });
})();
